/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Event_BeforeInputs */

const en_insert_event_before = /** @type {(inputs: Insert_Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert event before`)
};

const fr_insert_event_before = /** @type {(inputs: Insert_Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer un événement avant`)
};

const de_insert_event_before = /** @type {(inputs: Insert_Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge das Ereignis vor dem`)
};

const it_insert_event_before = /** @type {(inputs: Insert_Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci evento prima`)
};

const ru_insert_event_before = /** @type {(inputs: Insert_Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставьте событие перед`)
};

const es_insert_event_before = /** @type {(inputs: Insert_Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar evento antes`)
};

const zh_cn2_insert_event_before = /** @type {(inputs: Insert_Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在插入事件之前`)
};

const ja_insert_event_before = /** @type {(inputs: Insert_Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前にイベントを挿入`)
};

const hi_insert_event_before = /** @type {(inputs: Insert_Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इससे पहले इवेंट डालें`)
};

const pt_pt2_insert_event_before = /** @type {(inputs: Insert_Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir evento antes`)
};

/**
* | output |
* | --- |
* | "Insert event before" |
*
* @param {Insert_Event_BeforeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_event_before = /** @type {((inputs?: Insert_Event_BeforeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Event_BeforeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_event_before(inputs)
	if (locale === "de") return de_insert_event_before(inputs)
	if (locale === "it") return it_insert_event_before(inputs)
	if (locale === "ru") return ru_insert_event_before(inputs)
	if (locale === "es") return es_insert_event_before(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_event_before(inputs)
	if (locale === "ja") return ja_insert_event_before(inputs)
	if (locale === "hi") return hi_insert_event_before(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_event_before(inputs)
	return en_insert_event_before(inputs)
});